/* eslint-disable react/function-component-definition */
import React, { useImperativeHandle, useState, useRef } from 'react';
import ConfirmModal from '$/components/ConfirmModal';
import Button from '$/components/base/Button';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import type { ConfirmModalRef } from '$/components/ConfirmModal';
import styles from './index.module.scss';

export interface SuccessExchangeRef {
  open: (duration: string) => void;
}

interface ExchangeCodeProps {
  onClose: () => void;
  zIndex?: number;
}

/** 渲染会员兑换成功弹窗，层级跟随兑换码弹窗继续上浮。 */
const SuccessExchangeModal: React.ForwardRefRenderFunction<SuccessExchangeRef, ExchangeCodeProps> = (props, ref) => {
  const { onClose, zIndex } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [duration, setDuration] = useState('');
  const confirmModalRef = useRef<ConfirmModalRef>(null);
  const languageStore = useLanguageStore((state) => state.languageStore);
  useImperativeHandle(ref, () => ({
    open: (durationTime: string) => {
      setDuration(durationTime);
      confirmModalRef.current?.openModal();
    },
  }));

  return (
    <ConfirmModal
      ref={confirmModalRef}
      zIndex={zIndex}
      // eslint-disable-next-line react/no-unstable-nested-components
      confirmText={() => (
        <div className={styles['footer-btn']}>
          <Button
            type="primary"
            onClick={() => {
              confirmModalRef.current?.closeModal();
              onClose?.();
            }}
            buttonStyle={{ margin: '0 18px 18px', width: 'auto' }}
          >
            {languageStore.smartcatTranslationText((v) => v.roboneo_web_ot)}
          </Button>
        </div>
      )}
    >
      <div className={styles['successs-container']}>
        <IconFont name="checkCircleFill" color="var(--content-primaryAccent)" fontSize={60} />
        <div className={styles['success-tip-text']}>
          <div className={styles.title}>
            {languageStore.smartcatTranslationText((v) => v.redeemed_)}
          </div>
          {/* <div className={styles['code-detail']}> */}
          {/* {languageStore.smartcatTranslationText((v) => v.redeemed_)}  */}
          {/* 成功兑换 */}
          {/* {Number(duration)} */}
          {/* </div> */}

        </div>
      </div>
    </ConfirmModal>
  );
};
export default React.forwardRef(SuccessExchangeModal);
